import { FieldError, Input, Label, NumberField, TextField } from "react-aria-components";

interface ITextField {
    label?: string
    visibleLable: boolean
    icon?: any
    onChangeText: Function,
    required?: boolean,
    className?: string,
    disabled: boolean,
    max?: number
    min?: number
    value: string | undefined,
    validateRule?: Function,
    validationError?: string,
    step?: number
    autocomplete?: string
    name?: string
    inputType?: string
}

export default function AdobeYearField({ label, visibleLable, icon, onChangeText, required, className, max, min, disabled = false, value, validateRule, validationError, step, autocomplete, name, inputType }: ITextField) {

    function handleWheel(e: React.WheelEvent<HTMLInputElement>) {
        e.currentTarget.blur();
    }

    function validate(val: string) {
        if (!required && (!val || val === '')) return null;
        if (validateRule) {
            return validateRule(val) ? null : validationError;
        }
    }

    return (
        <TextField type="number" value={value} className={"search-field"} aria-label={label} onChange={(x) => { onChangeText(x) }} isDisabled={disabled} validate={validate}>
            {visibleLable && <Label className="small display--block margin__bottom--xxs">{label}{required ? " (required)" : ""}</Label>}
            <Input onWheel={handleWheel} type="number" />
            <img src={icon} />
            <FieldError />
        </TextField>
    )
}